<template lang="pug">
PageView(:title="$t('settings.title')", class="subpage", icon="settings", :fullWidth="true", backLink="/dashboard", backText="Back to Dashboard", :maxWidth="true", :largeMaxWidth="false", ref="pageview")
  template(slot="tabs")
    PageTab(:title="$t('settings.account')", :tabIndex="0", :active="currentTab === ''", icon="account-24", @click.native="handleLink($event, '/settings')" link="/settings")
    template(v-if="hasSubscriptionPlan")
      PageTab(:title="$t('settings.plan.billing')", :tabIndex="2", :active="currentTab === 'billing' || currentTab === 'plan'", icon="dollar-24", @click.native="handleLink($event, '/settings/billing')" link="/settings/billing")
    template(v-else)
      PageTab(:title="$t('settings.plan.title')", :tabIndex="2", :active="currentTab === 'plan'", icon="tune", @click.native="handleLink($event, '/settings/plan')" link="/settings/plan")
    template(v-if="featuresEnabled.includes('lvs') && activeSubscription")
      PageTab(:title="$t('settings.liveshopping.title')", :tabIndex="3", :active="currentTab === 'liveshopping'", icon="shoppingbag-24", @click.native="handleLink($event, '/settings/liveshopping')" link="/settings/liveshopping")
    template(v-if="featuresEnabled.includes('ppv')")
      PageTab(:title="$t('settings.payout')", :tabIndex="4", :active="currentTab === 'payout'", icon="money", @click.native="handleLink($event, '/settings/payout')" link="/settings/payout")
    PageTab(:title="$t('settings.streams')", :tabIndex="6", :active="currentTab === 'streams'", icon="stream-24", @click.native="handleLink($event, '/settings/streams')" link="/settings/streams")
  router-view
</template>

<script>
import { getQueryParameterValue } from '@/utils';

export default {
  computed: {
    /**
     * Return the current tab
     * @return {String}
     */
    currentTab() {
      const tab = this.$route.path.split('/').pop();
      return tab === 'settings' ? '' : tab;
    },
  },
  methods: {
    /**
     * Change tab
     * @param {String} tab
     */
    changeTab(tab) {
      this.$router.push(`/settings/${tab}`);
    },
    /**
     * Connect existing account from stripe with code from redirect Back to Dashboard
     * @param {String} code
     */
    async connectExistingAccount(code) {
      const connect = await this.$store.dispatch(
        'AccountManager/connectStripeAccount',
        code,
      );
      if (!connect) {
        swal({
          title: 'An error occured',
          text:
            'For some reason we could not set connect your Stripe account right now.',
          icon: 'error',
        });
        return;
      }

      await this.$store.dispatch('AccountManager/getAccount');
      this.$nextTick(() => {
        swal(`${this.$t('settings.stripe_account_connected')}!`, '', 'success');
      });
    },
  },
  mounted() {
    // Backup until we change stripe return url
    const error = getQueryParameterValue('error');
    const code = getQueryParameterValue('code');

    if (error !== '') {
      swal({
        title: 'An error occured',
        text:
          'For some reason we could not set connect your Stripe account right now.',
        icon: 'error',
      });
      return;
    }

    if (code !== '') {
      this.connectExistingAccount(code);
    }
  },
};
</script>
